// Faixa de aviso quando o WhatsApp do bot cai, está religando ou precisa de QR Code.
// O backend grava o estado em inquilinos/{tenant}.botStatus.
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiAlertTriangle, FiRefreshCw } from 'react-icons/fi';
import { doc, onSnapshot } from 'firebase/firestore';
import { firestore } from '../../config/firebaseConfig';
import './AvisoBot.css';

const MENSAGENS = {
  desconectado: 'O WhatsApp do bot está desconectado: os cursos e respostas estão parados.',
  aguardando_qr: 'O WhatsApp do bot precisa ser conectado de novo (leitura do QR Code).',
  reconectando: 'O WhatsApp do bot caiu e está religando sozinho.',
};

function AvisoBot({ tenantId }) {
  const [estado, setEstado] = useState(null);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!tenantId) return undefined;
    return onSnapshot(
      doc(firestore, 'inquilinos', tenantId),
      (d) => setEstado(d.exists() ? d.data().botStatus || null : null),
      (e) => console.error('Estado do bot:', e),
    );
  }, [tenantId]);

  // Na própria tela do bot o status já aparece
  if (!estado || !MENSAGENS[estado.status] || pathname.startsWith('/configuracao/bot')) return null;

  const religando = estado.status === 'reconectando';
  const Icone = religando ? FiRefreshCw : FiAlertTriangle;
  return (
    <div className={`qz-aviso-bot${religando ? ' qz-aviso-bot--info' : ''}`} role="status">
      <Icone aria-hidden="true" className="qz-aviso-bot__icone" />
      <span>
        {MENSAGENS[estado.status]}
        {estado.detalhe && <span className="qz-aviso-bot__detalhe"> {estado.detalhe}</span>}
      </span>
      {!religando && <Link to="/configuracao/bot" className="qz-aviso-bot__acao">Conectar o WhatsApp</Link>}
    </div>
  );
}

export default AvisoBot;
